import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { Trash2, Mail, MailOpen, Phone, User } from "lucide-react";
import { adminApi } from "../../lib/api";
import { toast } from "sonner";

export default function MessagesPage() {
  const [messages, setMessages] = useState([]);

  const load = () => adminApi.getMessages().then((r) => setMessages(r.data)).catch(console.error);
  useEffect(() => { load(); }, []);

  const handleMarkRead = async (id) => {
    try {
      await adminApi.markMessageRead(id);
      load();
    } catch (err) {
      toast.error("Error updating message");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    try {
      await adminApi.deleteMessage(id);
      toast.success("Message deleted");
      load();
    } catch (err) {
      toast.error("Error deleting message");
    }
  };

  const unread = messages.filter((m) => !m.read).length;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">Messages</h2>
          <p className="text-sm text-slate-500 mt-0.5">
            {unread > 0 ? `${unread} unread message${unread > 1 ? "s" : ""}` : "All messages read"}
          </p>
        </div>
      </div>

      {messages.length === 0 ? (
        <div className="text-center py-16 text-slate-400">No messages yet</div>
      ) : (
        <div className="space-y-4">
          {messages.map((m) => (
            <Card key={m.id} className={`border transition-colors ${!m.read ? "border-sky-200 bg-sky-50/30" : "border-slate-100"}`}>
              <CardContent className="p-5">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <div className="flex items-center gap-1.5">
                        <User className="w-4 h-4 text-slate-400" />
                        <span className="font-semibold text-slate-900">{m.name}</span>
                      </div>
                      {m.phone && (
                        <div className="flex items-center gap-1.5 text-sm text-slate-500">
                          <Phone className="w-3.5 h-3.5" />
                          <span>{m.phone}</span>
                        </div>
                      )}
                      {m.email && (
                        <span className="text-sm text-slate-500">{m.email}</span>
                      )}
                      {!m.read && <Badge className="bg-sky-100 text-sky-700 hover:bg-sky-100 text-xs">New</Badge>}
                    </div>
                    <p className="text-slate-700 text-sm leading-relaxed">{m.message}</p>
                    <p className="text-xs text-slate-400 mt-2">
                      {m.created_at ? new Date(m.created_at).toLocaleString("en-IN") : ""}
                    </p>
                  </div>
                  <div className="flex gap-2 flex-shrink-0">
                    {!m.read && (
                      <Button size="sm" variant="outline" onClick={() => handleMarkRead(m.id)} title="Mark as read">
                        <MailOpen className="w-4 h-4" />
                      </Button>
                    )}
                    <Button size="sm" variant="outline" onClick={() => handleDelete(m.id)} className="text-red-500 hover:text-red-600 hover:bg-red-50">
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
